import { createRouter, createWebHistory } from 'vue-router'

import { SellerRole } from '@/enums/seller.ts'
import { isAuthenticated } from '@/libs/auth'
import { hasRoles } from '@/libs/seller.ts'
import { useAppStore } from '@/stores/app'

const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) return savedPosition
        else if (to.hash) return { el: to.hash, behavior: 'smooth' }
        else if (from.path === to.path) return {}

        return {
            top: 1,
            behavior: 'smooth'
        }
    },
    routes: [
        {
            path: '/',
            name: 'dashboard',
            redirect: '/leads'
            // component: () => import('@/views/Dashboard.vue'),
            // meta: {
            //     requiresAuth: true
            // }
        },
        {
            path: '/sellers',
            name: 'sellers',
            component: () => import('@/views/seller/Sellers.vue'),
            meta: {
                requiresAuth: true,
                requiredRoles: [SellerRole.MANAGE_USERS]
            }
        },
        {
            path: '/profile',
            name: 'profile',
            component: () => import('@/views/profile/Profile.vue'),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/companies-that-not-exists',
            name: 'companies-that-not-exists',
            component: () => import('@/views/company/CompaniesThatDoesnotExist.vue'),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/companies',
            name: 'companies',
            component: () => import('@/views/company/Companies.vue'),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/company/:id',
            name: 'company',
            component: () => import('@/views/company/Company.vue'),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/business-units',
            name: 'business_units',
            component: () => import('@/views/company/components/CompanyBusinessUnits.vue'),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/business-unit/:id',
            name: 'business_unit',
            component: () => import('@/views/businessUnit/BusinessUnit.vue'),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/leads',
            name: 'leads',
            component: () => import('@/views/Lead/Leads.vue'),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/leads/sale',
            name: 'sale-leads',
            component: () => import('@/views/Lead/LeadsByStatus.vue'),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/leads/data-retrieval',
            name: 'data-retrieval-leads',
            component: () => import('@/views/Lead/LeadsByStatus.vue'),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/leads/installation',
            name: 'installation-leads',
            component: () => import('@/views/Lead/LeadsByStatusInstallation.vue'),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/leads/completed',
            name: 'completed-leads',
            component: () => import('@/views/Lead/LeadsByStatus.vue'),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/leads/rejected',
            name: 'rejected-leads',
            component: () => import('@/views/Lead/LeadsByStatus.vue'),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/leads/data-entry',
            name: 'data-entry-leads',
            component: () => import('@/views/Lead/LeadsByStatus.vue'),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/lead/:id',
            name: 'lead',
            component: () => import('@/views/Lead/Lead.vue'),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/lead/:id/business-unit/:business_unit_id',
            name: 'lead-business-unit',
            component: () => import('@/views/Lead/components/businessUnitSelectComponents/BusinessUnitInfo.vue'),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/leads/add',
            name: 'add-lead',
            component: () => import('@/views/Lead/AddLead.vue'),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/additional_requests',
            name: 'additional_requests',
            component: () => import('@/views/AdditionalRequest/AdditionalRequests.vue'),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/login',
            name: 'login',
            component: () => import('@/views/Login.vue'),
            meta: {
                layout: 'Blank',
                requiresAuth: false
            }
        },
        {
            path: '/:pathMatch(.*)*',
            redirect: '/'
        }
    ]
})

router.beforeEach((to) => {
    const loggedIn: boolean = isAuthenticated()
    const appStore = useAppStore()

    if (loggedIn && to.name === 'login') {
        return { name: 'dashboard' }
    }

    if (to.meta.requiresAuth && !isAuthenticated()) {
        appStore.setLogout()
        return { name: 'login' }
    }

    if (to.meta.requiredRoles && isAuthenticated()) {
        if (!hasRoles(...to.meta.requiredRoles)) {
            return { name: 'dashboard' }
        }
    }
})

export default router
